import React, { lazy } from "react";

const LazyAuditOverview = lazy(() => import("./AuditOverview"));

const AuditOverview = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAuditOverview {...props} />;

export default AuditOverview;
